import { render, staticRenderFns } from "./RepresentativeButtons.vue?vue&type=template&id=25cf819a&lang=html&"
import script from "./RepresentativeButtons.vue?vue&type=script&lang=js&"
export * from "./RepresentativeButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports